import React, { useState } from 'react'
import css from './FaqSection.module.css'
import IconCard from '../SavedCardDetails/IconCard/IconCard'
import classNames from 'classnames'

const FaqSection = ({ CustomizeStyle }) => {
    const [activeIndex, setActiveIndex] = useState(null)

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index)
    }

    const faqData = [
        {
            question: "Comment trouver le bon programme de formation ?",
            answer: "Vous pouvez rechercher par compétence, catégorie ou localisation pour découvrir des programmes de formation pertinents près de chez vous. Utilisez nos filtres pour affiner les options selon vos préférences."
        },
        {
            question: "Puis-je réserver des séances de formation en ligne ?",
            answer: "Oui, vous pouvez réserver des séances de formation directement via notre plateforme. Il suffit de trouver un programme qui vous intéresse, de vérifier la disponibilité et de réserver votre place instantanément."
        },
        {
            question: "Les formateurs sont-ils vérifiés ?",
            answer: "Tous les formateurs sur notre plateforme sont des professionnels vérifiés avec une expertise avérée dans leurs domaines respectifs. Nous examinons leurs qualifications et leur expérience avant approbation."
        },
        {
            question: "Quels modes de paiement sont acceptés ?",
            answer: "Nous acceptons divers modes de paiement, y compris les cartes de crédit/débit, les virements bancaires et les portefeuilles numériques. Le paiement est traité en toute sécurité via notre plateforme."
        },
        {
            question: "Puis-je annuler ou reporter ma réservation ?",
            answer: "Oui, vous pouvez annuler ou reporter votre réservation selon les conditions d’annulation définies par Formabel. Nous mettons en place des options flexibles afin de vous offrir la meilleure expérience possible. Pour plus de détails, nous vous invitons à consulter nos conditions générales ou à contacter notre service client."
        },
        {
            question: "Comment devenir formateur sur la plateforme ?",
            answer: "Pour devenir formateur, inscrivez-vous en tant que formateur, complétez votre profil avec vos qualifications et expérience, soumettez les documents de vérification et attendez l'approbation de notre équipe."
        }
    ]

    return (
        <div className={classNames(CustomizeStyle, css.faqSection)}>
            <div className={css.container}>
                <div className={css.faqContainer}>
                    <div className={css.faqList}>
                        {faqData.map((item, index) => (
                            <div
                                key={index}
                                className={`${css.faqItem} ${activeIndex === index ? css.active : ''}`}
                            >
                                <button
                                    className={css.faqQuestion}
                                    onClick={() => toggleAccordion(index)}
                                >
                                    <span>{item.question}</span>
                                    <span className={`${css.icon} ${activeIndex === index ? css.rotated : ''}`}>
                                        <IconCard brand={activeIndex === index ? 'accordionMinus' : 'accordionPlus'} />
                                    </span>
                                </button>

                                <div className={`${css.faqAnswer} ${activeIndex === index ? css.open : ''}`}>
                                    <p>{item.answer}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FaqSection
